const signalR = require("@aspnet/signalr");

export default class ExerciseHubService {
    constructor($rootScope, globalConstants)
    {
        this.buffer = [];
        this.keepAliveHandle = null;
        this.lastExerciseId = null;
        this.$rootScope = $rootScope;
        this.globalConstants = globalConstants;
        this.connection = new signalR.HubConnectionBuilder()
            .withUrl(this.globalConstants.SignalRBaseUrl + "/exercise")
            .build();

        this.connection.on("Send", data => {
            $rootScope.$apply(() => {

            $rootScope.$emit("Exercise.Send", data);
            })
        });

        this.connection.on("SendUpdate", data => { 
            $rootScope.$apply(() => {

            $rootScope.$emit("Exercise.SendUpdate", data);
            })
        });

        this.connection.on("SendFilterUpdate", data => {
            $rootScope.$apply(() => {

            $rootScope.$emit("Exercise.SendFilterUpdate", data);
            })
        });

        this.connection.on("OnJoined", data => {
            $rootScope.$apply(() => {
                $rootScope.$emit("Exercise.OnJoined", data);
            })
        });

        this.connection.on("OnPostUpdated", data => {
            $rootScope.$apply(() => {
                $rootScope.$emit("Exercise.OnPostUpdated", data);
            })
        });

        this.connection.on("OnPostDeleted", data => {
            $rootScope.$apply(() => {
                $rootScope.$emit("Exercise.OnPostDeleted", data);
            })
        });

        this.connection.on("OnExerciseStateChange", data => {
            $rootScope.$apply(() => {
                $rootScope.$emit("Exercise.OnExerciseStateChange", data);
            })
        });

        this.connection.on("OnExerciseStopped", data => {
            $rootScope.$apply(() => {
                $rootScope.$emit("Exercise.OnExerciseStopped", data);
            })
        });

        this.connection.on("TrendingUpdate", data => {
            $rootScope.$apply(() => {
                $rootScope.$emit("Exercise.TrendingUpdate", data);
            })
        });

        // this.connection.on("OnScheduledPostsChanged", data => {
        //     $rootScope.$apply(() => {
        //         $rootScope.$emit("Exercise.OnScheduledPostsChanged", data);
        //     })
        // });

        this.connection.onclose(error =>{
            console.log("WS:onclose - connection closed; " + error);
        });
    }

    join(exerciseId) {
        this.lastExerciseId = exerciseId;
        this.connection.start().then(() => {
            this.connection.invoke("join", exerciseId);
            this.keepAliveHandle = setInterval(this.keepAlive.bind(this), 1000);
        }).catch(err=>{
            console.log("Error: Cannot re-join - " + err);
        });
    }

    reset(exerciseId) {
        this.bufferedInvoke("reset", exerciseId);
    }

    toggleExerciseState(exerciseId) {
        this.bufferedInvoke("ToggleExerciseState", exerciseId);
    }

    endExercise(exerciseId) {
        this.bufferedInvoke("EndExercise", exerciseId);
    }

 
    likePost(model) {
        var msg = JSON.parse(JSON.stringify(model));
        this.bufferedInvoke("LikePost", msg);
    }

    sharePost(model) {
        var msg = JSON.parse(JSON.stringify(model));
        this.bufferedInvoke("SharePost", msg);
    }

    deletePost(exercideId, postId, parentPostId) {
        this.bufferedInvoke("DeletePost", {
            exerciseId: exercideId,
            postId: postId,
            parentPostId: parentPostId
        });
    }

    scheduleDraft(exerciseId, postId, delayInMinutes) {
        this.bufferedInvoke("ScheduleDraftAsync",  exerciseId, postId, delayInMinutes);
    }

    sendDraft(exerciseId, postId, copy) {
        this.bufferedInvoke("SendDraftAsync", exerciseId, postId, copy);
    }

    disconnect() {
        if(this.keepAliveHandle) {
            clearInterval(this.keepAliveHandle);
            this.keepAliveHandle = null;
        }
        this.connection.stop();
    }

    sendMessage(message) {
        var msg = JSON.parse(JSON.stringify(message));
        return this.connection.invoke("Send", msg); // don't use 'bufferedInvoke', as we want to return the promise in this context
    }

    // buffers messages and tries dispatch.  If the message fails to send, then the keepAlive will retry every N interval.
    bufferedInvoke() {
        this.buffer.push(Array.from(arguments));
        this.dispatch();
    }

    dispatch(){
        var l = text => console.log("execisehub.dispatch::" + text);
        if(this.connection.connection.connectionState === 1){
            while(this.buffer.length > 0){
                var params = this.buffer.shift();
                if(params) {
                    this.connection.invoke(...params)
                    .then(()=> { 
                        l(`invoke-SUCCESS (${params})`);
                    })
                    .catch(err => {
                        l(`invoke-FAIL (${params}): ${JSON.stringify(err)}`);
                    });
                }
            }
        }
    }

    keepAlive(){
        if(this.connection.connection.connectionState === 0){ // connecting
            // do nowt because we're already re-connecting
            console.log("keepAlive::reconnnecting");
        }else if(this.connection.connection.connectionState === 1){ // connected
            //console.log("keepAlive::dispatching");
            this.dispatch();
        }else if(this.connection.connection.connectionState === 2){ // disconnected
            // request reconnect
            console.log("keepAlive::attempting-reconnect");
            this.join(this.lastExerciseId);
        }
    }
}


// WEBPACK FOOTER //
// ./src/js/services/exercise.hub.service.js